<template>
  <Adsense class="adsbygoogle" data-ad-client="ca-pub-7038131727768741" data-language="ko" :data-ad-slot="adSlot" :ins-style="style" />
</template>

<script>
export default {
  props: ["type", "adSlot"],
  computed: {
    style() {
      if (this.type === "banner") {
        return "display:inline-block; width:auto; min-width:320px; min-height:50px"
      } else {
        return "display:inline-block; width:auto; min-width:300px; height:250px"
      }
    }
  }
}
</script>
